import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

type Props = {
  name: string;
  tag?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'teleport-target',
  props: {
    name: {},
    tag: { default: 'div' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag || 'div'), { id: __props.name }, null, 8, ["id"]))
}
}

})